export const state = () => {
	return {
		page_account: {},
		ttl_page_account: null,
		cache_duration_page_account: 3600000, // 1 heure
		cache_key_page_account: '',
	}
}

function isInCachePageAccount(state, companyId) {
	if (state.cache_key_page_account !== buildCacheKeyPageAccount(companyId)) {
		return false
	}
	if (state.ttl_page_account === null || state.ttl_page_account < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyPageAccount(companyId) {
	return 'company:' + companyId + ':page-account'
}

export const actions = {
	async get({ state, commit }, { companyId }) {
		if (isInCachePageAccount(state, companyId)) {
			return state.page_account
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/page-account/`)
			.then((res) => {
				commit('setPageAccount', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('invalidateCachePageAccount')
				throw err
			})
	},

	async create({ commit }, { companyId, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/page-account/`, { method: 'POST', body: data })
			.then((res) => {
				commit('setPageAccount', { data: res, companyId })
			})
			.catch((err) => {
				throw err
			})
	},

	async delete({ commit }, { companyId, pageAccountId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/page-account/${pageAccountId}/`, {
				method: 'DELETE',
			})
			.then((res) => {
				commit('clearCachePageAccount')
			})
			.catch((err) => {
				throw err
			})
	},
}

export const mutations = {
	setPageAccount(state, { data, companyId }) {
		state.page_account = data
		state.ttl_page_account = Date.now() + state.cache_duration_page_account
		state.cache_key_page_account = buildCacheKeyPageAccount(companyId)
	},

	clearCachePageAccount(state) {
		state.page_account = {}
		state.ttl_page_account = null
		state.cache_key_page_account = ''
	},

	invalidateCachePageAccount(state) {
		state.ttl_page_account = null
	},
}
